import styled, {css} from "styled-components";
import {Link, NavLink} from "react-router-dom";
import {Menu} from "antd";

export const HeaderNavMenu = styled.div`
  width: 100%;
  text-align: center;
  flex-grow: 1;  
`;

export const NavMenu = styled(Menu)`
  box-shadow: inset 0px -1px 0px ${props => props.theme.header_shadow};
  background: ${props => props.theme.header_bg};
  border-bottom: 0;
  &.ant-menu.ant-menu-dark{
    
  }
  &.ant-menu .ant-menu-item > span > a.active{
    color: ${props => props.theme.header_menu_active}!important;
  }
`;

export const NavMenuItem = styled(Menu.Item)`
  background-color: transparent!important;
  color: ${props => props.theme.header_menu_active}!important;
  position: relative;
  &.ant-menu-item-selected > span > a{
    color: ${props => props.theme.header_menu_active}!important;
  }
  &.ant-menu-item > span > a.active{
    color: ${props => props.theme.header_menu_active}!important;
  }
  &.ant-menu-item > span > a{
    color: ${props => props.theme.header_menu};
  }
  &.ant-menu-item a:hover{
    color: ${props => props.theme.header_menu_active}!important;
    opacity: 1;
  }
  .ant-menu-item-selected::after{
    border-bottom: 2px solid transparent;
  }
`;

export const MenuLink = styled(NavLink)`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  //color: #C9CED6;
  color: ${props => props.theme.header_menu}!important;
  text-transform: uppercase;  
`;

export const ALink = styled.a`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  color: #C9CED6;
  text-transform: uppercase;  
`;

export const AlertIndicator = styled.div`
  height: 16px;
  min-width: 16px;
  background-color: #FFCF80;
  color: black;
  border-radius: 8px;
  position: absolute;
  top: 10px;
  right: 10px;
  line-height: 14px;
  font-size: 10px;
  padding: 0 3px;
  text-align: center;
`;
